'use client'
import React, { useContext, useEffect, useState } from 'react';
import { PersonaContext } from '../../lib/personaContext';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import { Button, Flex, Text, Link, Tooltip, IconButton, useToast } from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';
import PersonaAsideUsefulLinksForm from './personaAsideUsefulLinksForm';
import { PersonaPageContext } from '../lib/personaPageContext';
export default function PersonaAsideUsefulLinks() {
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const [seeMore, setSeeMore] = useState(false);
  const [displaySeeMore, setDisplaySeeMore] = useState(true);
  const toast = useToast();
  const {
    editingUsefulLinks,
    setEditingUsefulLinks
  } = useContext(PersonaPageContext);
  const copyToClipboard = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast({
        title: "Link copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
    }
  };
  return (
    <> { (persona && 
      (
      <Flex px={3} py={2} flexDirection={"column"}>
        <InlineFormWrapper
          width={"100%"}
          canEdit={rights.can_update}
          toggle={editingUsefulLinks}
          onToggle={(toggle) => {
            setEditingUsefulLinks(toggle);
            setDisplaySeeMore(!toggle);
          }}
          value={
            <Flex flexDirection={"column"}>
              <Text
                color="text.medium.grey"
              >Useful Links</Text>
              <Flex flexDirection={"column"}>
                {(persona.useful_links && persona.useful_links.length > 0) && persona.useful_links.map((link, i) => (
                  <Flex key={i}>
                    {((i < 3) || (i >= 3 && seeMore)) &&
                      <Flex mt={1}>
                        <Tooltip 
                          label={link.url}
                          placement="top"
                          hasArrow
                        >
                          <Text 
                            fontWeight="medium" 
                            textDecoration="underline"
                            cursor="pointer"
                            color="text.medium.blue"
                            _hover={{ color: "fill.blue" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(link.url, '_blank');
                            }}
                          >
                            {link.title}
                          </Text>
                        </Tooltip>
                      </Flex>
                    }
                  </Flex>
                ))}
              </Flex>
            </Flex>
          }
        >
          {(close) => (
            <PersonaAsideUsefulLinksForm
              onSubmitted={close}
              onCancel={close}
            />
          )}
        </InlineFormWrapper>
      </Flex>
      )
    )}</>
  )
} 